import React, { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useHistory } from "react-router-dom";
import { Base64 } from "js-base64";
import AuthService from "../../../Services/AuthService";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { message } from "antd";
import { generateAesKey } from "../../../utils/passwordEncrypt";
import AppointmentService from "../../../Services/AppointmentService";
import ConsultationService from "../../../Services/ConsultationService";
import PatientService from "../../../Services/PatientService";
import CommonFunctions from "../../Shared/CommonFunctions";
import { notifyPatient } from "../../../config/firebase";
import { saveLoggedUser, setSelectedAppt } from "../../../Redux/actions/UserActions";
import { useDispatch } from "react-redux";

function DirectJoinCall() {
  const [showPassword, setShowPassword] = useState(false);
  const [disable, setDisable] = useState(false);
  const [eror, setError] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();
  const [appointmentDetails, setAppointmentDetails] = useState(null);
  const [callDetails, setCallDetails] = useState(null);
  const dispatch = useDispatch();

  const getCodeFromURL = () => {
    const query = window.location.search;
    const codeMatch = query.match(/ref=([^/&]*)/);
    return codeMatch ? codeMatch[1] : null;
  };

  useEffect(() => {
    let param = getCodeFromURL();
    if (param) {
      getAppointmentDetails(param);
    }
  }, []);

  const getAppointmentDetails = async (id) => {
    setDisable(true);
    try {
      let appointmentDetails = await AppointmentService.GetAppointmentId(id);
      setAppointmentDetails(appointmentDetails?.data[0]);

      let joinCallDetails = await AuthService.DirectJoinCallDetails(id);
      setCallDetails(joinCallDetails?.data[0]);
      setDisable(false);
    } catch (error) {
      setDisable(false);
    }
  };

  const handleClick = async (record) => {
    if (appointmentDetails.status == 1) {
      let payload = {
        appointmentId: record.appointmentId,
        modifiedBy: record.userId,
        modifiedDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        patientId: record.patientId,
        startDateTime: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        userId: record.userId,
        userName: record?.userName,
        personType: "Doctor",
      };

      let updateJoinTime = await ConsultationService.updateStartTime(payload);
    }
    let payload = {
      patientId: record.patientId,
    };

    PatientService.PatientListFilter(payload).then((res) => {
      sessionStorage.setItem("patient", JSON.stringify(res.data[0]));
    });
    await notifyPatient(record.patientId, record.appointmentId, record.userName, record.userId);
    dispatch(setSelectedAppt(record));
    sessionStorage.setItem("selectedAppt", JSON.stringify(record));
    history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: record });
  };

  const handleLogin = async () => {
    let userName = callDetails?.userEmail;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!userName) {
      setError("Please enter User ID or Email");
      return;
    }
    setDisable(true);
    let payload = {
      password: Base64.encode(password),
      userId: isNaN(userName) ? userName : `U${userName}`,
    };
    if (!payload.userId || !payload.password) {
      message.error("please enter valid credentials to login");
      setDisable(false);
      return;
    }
    try {
      const res = await AuthService.TokenAuthentication(payload);
      sessionStorage.setItem("access_token", res.data.access_token);
      sessionStorage.setItem("refresh_token", res.data.refresh_token);
      if (res.data.error === "1") {
        message.error(res.data.error_description);
        setDisable(false);
        return;
      }
      const encryptedPass = generateAesKey(password);
      let data1 = {
        currentVal: encryptedPass,
        userCode: userName,
      };
      const loginResult = await AuthService.Login(data1);

      if (!loginResult.data.message) {
        if (
          loginResult.data.user.rolecode !== "SUPERADMIN" &&
          loginResult.data.user.userType == "P"
        ) {
          sessionStorage.setItem(
            "login_result",
            JSON.stringify(loginResult.data)
          );
          dispatch(saveLoggedUser(loginResult.data));
          sessionStorage.setItem(
            "defaultClinic",
            loginResult?.data?.user?.clinic_Id
          );

          // history.push(APP_ROUTES.DASHBOARD);
          handleClick(appointmentDetails);
          message.success(
            `Welcome ${loginResult.data.user.firstName} ${loginResult.data.user.lastName}`
          );
        } else {
          message.error("Invalid Credentials, verify and try again");
          setDisable(false);
        }
      } else {
        message.error(loginResult.data.message);
        setDisable(false);
      }
    } catch (error) {
      message.error("An Error occured. Please Try Again");
      setDisable(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      {disable && (
        <div class="fixed inset-0 flex items-center justify-center bg-white  z-50">
          <div className="spinner"></div>
        </div>
      )}
      <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-md">
        <div className="flex flex-col justify-center items-center">
          <div className="text-xl font-semibold text-center mb-2 text-gray-800">
            Welcome {callDetails?.userName}
          </div>
          <div className="mb-6">
            <span className="font-semibold">{callDetails?.userEmail}</span>
          </div>
        </div>

        <div className="mb-3">
          <p className="text-gray-700 font-medium"></p>
        </div>

        <div className="mb-6 relative">
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            id="password"
            className="w-full px-4 py-2 border border-gray-300 rounded-md pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your password"
          />
          <button
            onClick={() => setShowPassword((prev) => !prev)}
            className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 focus:outline-none bg-white"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>

        <button
          onClick={handleLogin}
          type="submit"
          className="w-full  text-white py-2 rounded-md  transition duration-200"
        >
          Join Call with {callDetails?.patientName}
        </button>
      </div>
    </div>
  );
}

export default DirectJoinCall;
